/* AQUERIE PDP — Section 1 behaviour.
   IIFE with no top level declarations, matching motion.js, so it can drop into
   a GemPages Custom Code block or a Liquid section unchanged. */
(function () {
  'use strict';

  var root = document.querySelector('.pdp');

  if (!root) return;


  /* Cart config, read once. Declared before anything uses it. */
  var cfgEl = document.getElementById('aq-cart-config');
  var CFG = {};
  if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) {} }

  /* ---- gallery ---- */
  var mainImg = document.getElementById('pdp-main-img');
  var thumbs = root.querySelectorAll('.pdp__thumb');

  Array.prototype.forEach.call(thumbs, function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.getAttribute('data-full');
      mainImg.srcset = btn.getAttribute('data-srcset');
      mainImg.alt = btn.getAttribute('data-alt') || '';
      Array.prototype.forEach.call(thumbs, function (b) {
        b.setAttribute('aria-current', b === btn ? 'true' : 'false');
      });
    });
  });

  /* ---- quantity stepper ---- */
  var qtyInput = root.querySelector('.pdp__qty input');
  Array.prototype.forEach.call(root.querySelectorAll('.pdp__qty button'), function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.getAttribute('data-step'), 10);
      qtyInput.value = next < 1 ? 1 : next;
    });
  });

  /* ---- plan selection ----
     Prices come from the two variants via aq-cart-config, which the template
     fills from variant.price, so they cannot drift from admin or from
     checkout. Deliberately no hardcoded fallback: if a price is missing we
     leave the server rendered figure in the DOM rather than overwrite it with
     a stale literal, which is exactly how this page came to show £45.59 long
     after the real price had changed. */
  var PLANS = {
    subscribe: { price: CFG.planPrice,    label: 'First order today' },
    onetime:   { price: CFG.oneTimePrice, label: 'Total today' }
  };
  var atcPrice   = document.getElementById('pdp-atc-price');
  var firstPrice = document.getElementById('pdp-first-price');
  var firstLabel = document.getElementById('pdp-first-label');
  var subOnly    = root.querySelectorAll('[data-sub-only]');
  var oneOnly    = root.querySelectorAll('[data-one-only]');

  function applyPlan(value) {
    var plan = PLANS[value] || PLANS.subscribe;
    if (plan.price) {
      if (atcPrice)   atcPrice.innerHTML   = plan.price;
      if (firstPrice) firstPrice.innerHTML = plan.price;
    }
    if (firstLabel) firstLabel.textContent = plan.label;
    /* The two plans ship different boxes, so some rows belong to one and some
       to the other. Subscribe adds the hose and the long lasting refill, one
       time gets the standard spare refill instead. */
    var subscribing = value === 'subscribe';
    Array.prototype.forEach.call(subOnly, function (row) {
      row.style.display = subscribing ? '' : 'none';
    });
    Array.prototype.forEach.call(oneOnly, function (row) {
      row.style.display = subscribing ? 'none' : '';
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('input[name="plan"]'), function (input) {
    input.addEventListener('change', function () { applyPlan(input.value); });
    if (input.checked) applyPlan(input.value);
  });

  /* ---- expected delivery ----
     Recomputed from the visitor's own clock, so a page served from cache on a
     later day still shows a correct window and the dates can never freeze the
     way the old hardcoded '29 Aug to 4 Sept' did. The Liquid template renders
     the same window server side as the no JS fallback. */
  var eta = document.getElementById('pdp-eta');
  if (eta) {
    var etaDay = function (days) {
      var d = new Date();
      d.setDate(d.getDate() + days);
      return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    };
    var etaLo = parseInt(eta.getAttribute('data-eta-min'), 10) || 3;
    var etaHi = parseInt(eta.getAttribute('data-eta-max'), 10) || 9;
    eta.textContent = etaDay(etaLo) + ' to ' + etaDay(etaHi);
  }

  /* ---- reviews: show more ----
     Only the first batch is in the document. The rest are fetched once from
     assets/reviews.json and appended, so the page does not ship 254 reviews
     of HTML to every visitor. */
  var moreBtn = document.querySelector('.rv__more');
  if (moreBtn) {
    var STEP = 8;
    var cache = null;

    var starSvg = function (on) {
      return '<svg viewBox="0 0 20 20" aria-hidden="true" class="' + (on ? 'is-on' : '') +
        '"><path d="M10 1.6l2.5 5 5.5.8-4 3.9.9 5.5L10 14.2l-4.9 2.6.9-5.5-4-3.9 5.5-.8L10 1.6z"/></svg>';
    };
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    var meterHtml = function (label, scale, v) {
      if (v == null) return '';
      return '<div class="rv__meter"><p class="rv__meter-label">' + esc(label) + '</p>' +
        '<div class="rv__meter-track"><span class="rv__meter-dot" style="left:' + Math.round(v * 100) + '%"></span></div>' +
        '<div class="rv__meter-scale">' + scale.map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('') + '</div></div>';
    };

    /* Photos a customer sent in with their review. One, or two side by side.
       Same shape as the cards already in the page: <src>-600.webp with a 360w
       alternate, resolved against window.AQ_ASSETS inside the Shopify theme. */
    var IMG = (window.AQ_ASSETS || 'assets/img/');
    var mediaHtml = function (m) {
      if (!m) return '';
      var shots = Array.isArray(m) ? m : [m];
      var one = function (s) {
        return '<div class="rv__media"><img src="' + IMG + esc(s.src) + '-600.webp" ' +
          'srcset="' + IMG + esc(s.src) + '-360.webp 360w, ' + IMG + esc(s.src) + '-600.webp 600w" ' +
          'sizes="(max-width: 767px) 42vw, 152px" ' +
          'width="' + (s.w || 1200) + '" height="' + (s.h || 1600) + '" ' +
          'loading="lazy" decoding="async" alt="' + esc(s.alt) + '"></div>';
      };
      return shots.length > 1
        ? '<div class="rv__media-row">' + shots.map(one).join('') + '</div>'
        : one(shots[0]);
    };

    var cardHtml = function (r, data) {
      var meta = '';
      if (r.hardness || r.concern || r.changes) {
        meta = '<dl class="rv__meta">' +
          (r.hardness ? '<dt>Water Hardness</dt><dd>' + esc(r.hardness) + '</dd>' : '') +
          (r.concern ? '<dt>Primary Concern</dt><dd>' + esc(r.concern) + '</dd>' : '') +
          (r.changes ? '<dt>Changes Noticed</dt><dd>' + esc(r.changes) + '</dd>' : '') + '</dl>';
      }
      var stars = '';
      for (var i = 1; i <= 5; i++) stars += starSvg(i <= r.stars);

      return '<article class="rv__item"' + (data.placeholder ? ' data-placeholder="true"' : '') + '>' +
        '<div class="rv__who"><div class="rv__id"><span class="rv__avatar" aria-hidden="true">' + esc(r.initials) + '</span>' +
        '<div><p class="rv__name">' + esc(r.name) + '</p>' +
        (r.verified ? '<p class="rv__verified"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>Verified buyer</p>' : '') +
        '</div></div>' + meta + '</div>' +
        '<div class="rv__body"><div class="rv__body-head"><span class="rv__stars" role="img" aria-label="Rated ' + r.stars + ' out of 5">' + stars + '</span>' +
        '<span class="rv__date">' + esc(r.date) + '</span></div>' +
        (r.title ? '<h4 class="rv__h">' + esc(r.title) + '</h4>' : '') +
        '<p class="rv__text">' + esc(r.body) + '</p>' + mediaHtml(r.media) + '</div>' +
        (r.effectiveness != null || r.satisfaction != null
          ? '<div class="rv__item-meters">' +
            meterHtml('Effectiveness', data.attributes[0].scale, r.effectiveness) +
            meterHtml('Overall Satisfaction', data.attributes[1].scale, r.satisfaction) +
            '</div>'
          : '') + '</article>';
    };

    moreBtn.addEventListener('click', function () {
      var list = document.querySelector('.rv__list');
      var shown = parseInt(moreBtn.getAttribute('data-shown'), 10);
      var total = parseInt(moreBtn.getAttribute('data-total'), 10);

      var append = function (data) {
        var next = data.items.slice(shown, shown + STEP);
        list.insertAdjacentHTML('beforeend', next.map(function (r) { return cardHtml(r, data); }).join(''));
        shown += next.length;
        moreBtn.setAttribute('data-shown', shown);
        if (shown >= total) moreBtn.parentNode.removeChild(moreBtn);
        else moreBtn.textContent = 'Show more reviews';
      };

      if (cache) { append(cache); return; }
      moreBtn.textContent = 'Loading...';
      fetch(CFG.reviewsUrl || 'assets/reviews.json')
        .then(function (r) { return r.json(); })
        .then(function (d) { cache = d; append(d); })
        .catch(function () { moreBtn.textContent = 'Could not load reviews'; });
    });
  }

  /* ---- add to basket ----
     Subscribe posts TWO line items in one /cart/add.js call: the discounted
     filter variant plus the refill carrying the selling plan. One time posts
     the full price filter alone. Shopify accepts an items array, so this is a
     single request and a single cart drawer open. */
  var form = document.getElementById('aq-buy');

  function buildItems(plan, qty) {
    if (plan === 'subscribe') {
      if (!CFG.filterWithPlan || !CFG.refill || !CFG.sellingPlan) return null;
      return [
        { id: CFG.filterWithPlan, quantity: qty },
        { id: CFG.refill, quantity: qty, selling_plan: CFG.sellingPlan }
      ];
    }
    if (!CFG.filterOneTime) return null;
    return [{ id: CFG.filterOneTime, quantity: qty }];
  }

  if (form) {
    var atcBtn = form.querySelector('.pdp__atc');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var planEl = root.querySelector('input[name="plan"]:checked');
      var plan = planEl ? planEl.value : 'subscribe';
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var items = buildItems(plan, qty);

      if (!items) {
        console.warn('[aq] Cart not wired yet. Set the filter variant ids in aq-cart-config.', CFG);
        if (atcBtn) {
          var was = atcBtn.innerHTML;
          atcBtn.innerHTML = 'Variant ids not set';
          setTimeout(function () { atcBtn.innerHTML = was; }, 2200);
        }
        return;
      }

      /* On the local static preview there is no /cart/add.js, so log the exact
         payload instead. On Shopify the same code posts for real. */
      var isLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
      if (isLocal) {
        console.log('[aq] would POST /cart/add.js', JSON.stringify({ items: items }, null, 2));
        if (atcBtn) {
          var w2 = atcBtn.innerHTML;
          atcBtn.innerHTML = 'Payload logged to console';
          setTimeout(function () { atcBtn.innerHTML = w2; }, 2200);
        }
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'add failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.AQCartDrawer && window.AQCartDrawer.open) window.AQCartDrawer.open();
        })
        .catch(function (err) {
          console.error('[aq] add to basket failed', err);
          if (atcBtn) {
            var w3 = atcBtn.innerHTML;
            atcBtn.innerHTML = 'Could not add, try again';
            setTimeout(function () { atcBtn.innerHTML = w3; }, 2400);
          }
        });
    });
  }
})();
